module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAASCAIAAAD9mVSFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAI9JREFUeNrs2iEOgzAUgOGyzHELVA0Xgou8I/R+eHw99Vu2pHLBkYzvU09UvfxpKjrknNPHsizruib4LxGxbdt3flgH9yF35A5yB7mD3EHuIHeQO8gd5A5yB7lzN88+1Vr7x7EfxnGcpsniuFZrbd/3MyeP4+jz0D8AnzTPcynFurnW+2qOCI8ZkDuk9BJgAKpGGyXovqGJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RASM600.png
// module id = 2Ys4
// module chunks = 0